export type IconTagVariant = 'default' | 'approval';

export const ICON_TAG_VARIANT_CLASSES: Record<IconTagVariant, string> = {
  default: 'border-sky-100 text-sky-600',
  approval: 'border-amber-100 text-amber-600',
};
